'use strict';

var React = require('react');

var SvgPaymentsMajor = function SvgPaymentsMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m4.002 5-3.452 1.76a.985.985 0 0 0-.549.9v10.34c0 .51.38.93.879.99l8.023 1a.997.997 0 0 0 1.068-.67l1.766-5.32h3.273c1.297 0 2.405-.84 2.814-2h.679c.828 0 1.497-.67 1.497-1.5v-5.5h-15.998zm.998 5h10.01c.27 0 .509.1.709.31.19.18.289.42.289.69 0 .55-.449 1-.998 1h-3.992c-.429 0-.808.28-.948.68l-1.736 5.23-6.338-.79v-8.85l2.006-1v1.74a1 1 0 0 0 .998.99zm13.503-9h-13.004c-.828 0-1.497.67-1.497 1.5v.5h15.998v-.5c0-.83-.669-1.5-1.497-1.5z"
  }));
};

exports.SvgPaymentsMajor = SvgPaymentsMajor;
